import React from "react";
import SubNav from 'ROOT_SOURCE/components/SubNav'
import "./index.scss";

const Notice = () => (
    <div className="Notice">
        <SubNav selected="home" />
        <div className="main-box">
            <h1 className="title">关于北京五八钱柜信息技术有限公司退出网贷业务 <br />及出借人提现提醒公告</h1>
            <div className="content">
                <p className="greet">广大柜蜜们，你们好：</p>
                <p>我司于2019年12月31日停止P2P业务并完成存量提前到期停止服务工作，出借人本息已完成100%兑付。期间我司通过公示及短信提醒等方式通知出借人尽快提现，但仍有部分客户未对账户余额进行全额提现，导致清退工作停滞不前。为加快完成清退工作，我司委托存管行（四川新网银行）协助对部分出借人余额进行代转款，已将出借人账户余额（即未提现资金）转至其在钱柜绑定的银行账户。为保障剩余未提现出借人的合法权益，未提现出借人资金仍将在四川新网银行进行存管，请尽快完成剩余金额的提现操作。</p>
                <p>
                    如有疑问请联系我司客服：10105800，或联系海淀区网贷领域风险调节中心投诉电话：010-88864100。
                </p>
            </div>
            <div className="drop">
                <p>北京五八钱柜信息技术有限公司</p>
                <p>二零二零年十月二十一日</p>
            </div>
        </div>
    </div>
);

export default Notice;



// WEBPACK FOOTER //
// ./src/containers/Notice/index.js